module.exports = __webpack_public_path__ + "img/TN.c44ec512.png";